import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { XIcon, InfoCircleIcon } from '@repo/icons';
const outlineColorStyles = {
    ghost: '',
    gray: 'border bg-secondary border-stroke-base-medium text-heading',
    white: 'border bg-primary-soft border-stroke-base text-heading',
    brand: 'border bg-brand-softer border-stroke-brand-subtle text-brand',
    danger: 'border bg-danger-soft border-stroke-danger-subtle text-fg-danger-strong',
    warning: 'border bg-warning-soft border-stroke-warning-subtle text-fg-warning',
    success: 'border bg-success-soft border-stroke-success-subtle text-fg-success-strong',
};
const solidColorStyles = {
    ghost: 'bg-secondary text-heading',
    gray: 'bg-tertiary text-heading',
    white: 'bg-primary text-heading',
    brand: 'bg-brand text-white',
    danger: 'bg-danger text-white',
    warning: 'bg-warning text-white',
    success: 'bg-success text-white',
};
const variantStyles = {
    outline: outlineColorStyles,
    solid: solidColorStyles,
};
export default function InfoCard({ testId, title, icon = InfoCircleIcon, children, onClose, subtitle, color = 'brand', variant = 'outline', rightContent, }) {
    const Icon = icon;
    return (_jsxs("div", { className: classNames('relative flex items-start gap-3 rounded-xl p-4', variantStyles[variant][color]), "data-testid": testId, children: [_jsx(Icon, { className: "-mt-0.5 size-5 shrink-0" }), _jsxs("div", { className: "flex flex-1 flex-col gap-2", children: [title && _jsx("p", { className: "text-sm font-medium", children: title }), subtitle && _jsx("p", { className: "text-sm", children: subtitle }), children] }), rightContent, onClose && (_jsx("button", { type: "button", onClick: onClose, className: "-mt-1 -mr-1 cursor-pointer p-1", "data-testid": testId.append('close'), children: _jsx(XIcon, { className: "size-4" }) }))] }));
}
